import {Aggregator} from "./aggregator";

export enum AggregateFunctionType {

    SUM             = 'sum',
    MIN             = 'min',
    MAX             = 'max',
    MEDIAN          = 'median',
    AVERAGE         = 'average',
    RANGE           = 'range',
    CHECKED_TOTAL   = 'checkedTotal'
}


export type Aggregators = {

    [fieldId: fieldId]  : Aggregator

}